import { renderMoney } from "@/service/ecommerce/currency";
import { createPath } from "@/service/routing/routing";
import { SuperLink as Link } from "@/components/common/super-link";
import { Badge } from "@/components/ui/badge";
import { TagIcon } from "lucide-react";

export const PriceLink = ({
  product,
  link,
}: {
  product: ProductPriceOneVariantVM;
  link: string;
}) => {
  const actualPrice = product.promotionPrice
    ? product.promotionPrice
    : product.price;

  return (
    <Link href={product.inCart ? createPath("ecommerce") : link}>
      <Badge
        className={
          "bg-remedium-blue flex items-center gap-1.5 font-semibold text-white"
        }
      >
        <TagIcon className={"stroke-white"} />
        {renderMoney(actualPrice)}
      </Badge>
    </Link>
  );
};
